import { Reducer } from 'redux'

import { SortOrder } from '../../../types/common/commonTypes'
import {
    InventoryFacets,
    InventoryFilters,
    InventoryPartListItem,
    InventorySortField,
} from '../../../types/inventory/inventoryTypes'
import { storeDispatchTypes } from '../storeDispatchTypes'

export type InventoryState = {
    isLoading: boolean
    isFacetsLoading: boolean
    isPrinting: boolean
    data: InventoryPartListItem[]
    dataCount: number
    total: number
    facets: InventoryFacets
    filters: InventoryFilters
    pagination: {
        page: number
        perPage: number
    }
    order: [InventorySortField, SortOrder][]
}

export const defaultInventoryFacets: InventoryFacets = {
    warehouses: [],
    rows: [],
    shelves: [],
    places: [],
}

export const defaultInventoryState: InventoryState = {
    isLoading: false,
    isFacetsLoading: false,
    isPrinting: false,
    data: [],
    dataCount: 0,
    total: 0,
    facets: defaultInventoryFacets,
    filters: {
        search: '',
        warehouseId: '',
        warehouseRow: '',
        warehouseShelf: '',
        warehousePlace: '',
        warehouseSection: '',
    },
    pagination: {
        page: 1,
        perPage: 50,
    },
    order: [],
}

const createInventoryReducer: Reducer<InventoryState> = (state = defaultInventoryState, action) => {
    switch (action.type) {
        case storeDispatchTypes.setInventoryLoading:
            return { ...state, isLoading: action.value }
        case storeDispatchTypes.setInventoryFacetsLoading:
            return { ...state, isFacetsLoading: action.value }
        case storeDispatchTypes.setInventoryPrinting:
            return { ...state, isPrinting: action.value }
        case storeDispatchTypes.setInventoryPartList:
            return {
                ...state,
                data: action.value.data || [],
                dataCount: action.value.dataCount || 0,
                total: action.value.total || 0,
                facets: action.value.facets || state.facets,
            }
        case storeDispatchTypes.setInventoryFacets:
            return { ...state, facets: action.value || defaultInventoryFacets }
        case storeDispatchTypes.setInventoryFilter:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.value,
                },
                pagination: {
                    ...state.pagination,
                    page: 1,
                },
            }
        case storeDispatchTypes.setInventoryPagination:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.value,
                },
            }
        case storeDispatchTypes.setInventorySort:
            return { ...state, order: action.value || [] }
        case storeDispatchTypes.updateInventoryPartQty:
            return {
                ...state,
                data: state.data.map(item =>
                    item.id === action.value.partId ? { ...item, qty: action.value.qty } : item,
                ),
            }
        case storeDispatchTypes.resetInventoryFilters:
            return {
                ...state,
                filters: defaultInventoryState.filters,
                pagination: defaultInventoryState.pagination,
                order: [],
            }
        default:
            return state
    }
}

export default createInventoryReducer
